import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Uri from 'jsuri';

export default class PopularShow extends Component {
	constructor(props) {
		super(props);

		this.uri = new Uri(window.location.search);

		this.state = {
			"popularShow": props.popularShow,
			"popularShowShorten": this.shortenName(props.popularShow)
		};
	}

	shortenName(name) {
		let maxLength = 15;

		let shortenName = (name.length > maxLength) ? name.substr(0, maxLength-1) + '…' : name;
		return shortenName;
	}

	render() {
		this.popularShowLink = this.uri.clone().replaceQueryParam('q', this.state.popularShow).toString();

		return [
			<Link to={this.popularShowLink} key="0" title={this.state.popularShow}>
				{this.state.popularShowShorten}
			</Link>
		];
	}
}


// WEBPACK FOOTER //
// ./src/PopularShow.js